import { Link } from 'react-router-dom'
import { Mail } from 'lucide-react'
import { SOCIAL_MEDIA, CONTACT } from '@/lib/constants'
import { LinkedInIcon, InstagramIcon, FacebookIcon } from './icons/social-icons'
import { NewsletterSignup } from './NewsletterSignup'

export function Footer() {
  return (
    <footer className="bg-card border-border border-t">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 py-12 text-sm md:grid-cols-3">
        {/* Left: Branding & Copyright */}
        <div className="text-muted-foreground space-y-2">
          <p className="text-foreground font-serif text-xl">Fugue Lab</p>
          <p>Websites & Digital Strategy for Classical Music</p>
          <p>© {new Date().getFullYear()} Fugue Lab. All rights reserved.</p>
          <NewsletterSignup className="max-w-xs pt-4" />
        </div>

        {/* Center: Navigation */}
        <div className="text-muted-foreground flex flex-col space-y-2 md:items-center md:space-y-1">
          <p className="text-muted text-xs tracking-wider uppercase">Explore</p>
          <Link to="/" className="hover:text-foreground transition">
            Home
          </Link>
          <Link to="/packages" className="hover:text-foreground transition">
            Packages & Pricing
          </Link>
          <Link to="/who-we-help" className="hover:text-foreground transition">
            Who We Help
          </Link>
          <Link to="/resources" className="hover:text-foreground transition">
            Resources
          </Link>
          <Link to="/portfolio" className="hover:text-foreground transition">
            Portfolio
          </Link>
          <Link to="/how-we-measure" className="hover:text-foreground transition">
            How We Measure
          </Link>
          <Link to="/about" className="hover:text-foreground transition">
            About
          </Link>
          <Link to="/contact" className="hover:text-foreground transition">
            Contact
          </Link>
          <p className="text-muted mt-4 text-xs tracking-wider uppercase">For Clients</p>
          <Link to="/requests" className="hover:text-foreground transition">
            Request an Update
          </Link>
        </div>

        {/* Right: Contact & Socials */}
        <div className="text-muted-foreground space-y-2 md:text-right">
          <p className="text-xs tracking-wider uppercase">Contact</p>
          <p>Based in Los Angeles, CA</p>
          <p>
            <a
              href={`mailto:${CONTACT.email}`}
              className="hover:text-foreground flex items-center justify-center gap-1 transition md:justify-end"
            >
              <Mail className="h-4 w-4" />
              {CONTACT.email}
            </a>
          </p>
          <div className="flex justify-center gap-4 pt-2 md:justify-end">
            <a
              href={SOCIAL_MEDIA.linkedin}
              className="hover:text-foreground transition"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedInIcon className="h-5 w-5" />
            </a>
            <a
              href={SOCIAL_MEDIA.instagram}
              className="hover:text-foreground transition"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon className="h-5 w-5" />
            </a>
            <a
              href={SOCIAL_MEDIA.facebook}
              className="hover:text-foreground transition"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FacebookIcon className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>

      {/* Legal links + Made by Fugue */}
      <div className="text-muted-foreground space-y-2 pb-6 text-center text-xs">
        <div className="flex justify-center gap-4">
          <Link to="/privacy" className="hover:text-foreground transition">
            Privacy Policy
          </Link>
          <Link to="/accessibility" className="hover:text-foreground transition">
            Accessibility
          </Link>
        </div>
        <div>
          Designed and built by{' '}
          <a href="https://fuguelab.com" className="text-primary underline" target="_blank" rel="noopener noreferrer">
            Fugue Lab
          </a>
        </div>
      </div>
    </footer>
  )
}
